// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 16:01:52

export default {
  "id": "mahjong-pet-quest",
  "slug": "mahjong-pet-quest",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/085ee64625774fe598da8fc6690f6b2c-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/085ee64625774fe598da8fc6690f6b2c/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Mahjong Pet Quest",
      "description": "Dive into the colorful and engaging world of Mahjong Pet Quest, a fun and relaxing puzzle game where classic Mahjong meets adorable animal tiles!\nReplace the classic Mahjong tiles with cute animal-themed ones! Each tile brings a charming, delightful touch to the game.\nExplore a variety of levels, each designed to test your skills and logic. The difficulty increases as you progress, ensuring that you’re always challenged!",
      "instructions": " Match pairs of animal tiles to clear the board. \n You can only match tiles that are free and have no other tiles blocking them! \n Clear all the tiles to complete the level and move on to the next.",
      "genres": [
        "Mahjong & Connect"
      ],
      "tags": [
        "3d",
        "animal",
        "connection",
        "logic",
        "matching"
      ]
    },
    "zh-CN": {
      "title": "麻将宠物大冒险",
      "description": "沉浸在五彩缤纷、引人入胜的麻将宠物大冒险世界中，这是一款有趣轻松的益智游戏，其中经典的麻将与可爱的动物瓷砖相遇！\n用可爱动物主题瓷砖替换经典麻将瓷砖！每一块瓷砖都为游戏增添了迷人、愉悦的元素。\n探索各种级别，每个级别都旨在考验你的技能和逻辑。随着你的进度，难度逐渐提升，确保你始终保持挑战！",
      "instructions": "匹配动物拼图配对以清除棋盘。\n您只能匹配空闲且未被其他拼图遮挡的拼图！\n清除所有拼图以完成关卡并进入下一关。",
      "genres": [
        "麻将 & 连接"
      ],
      "tags": [
        "3D",
        "动物",
        "连接",
        "逻辑",
        "匹配"
      ]
    },
    "zh-TW": {
      "title": "麻將寵物冒險之旅",
      "description": "沉浸於五彩繽紛且引人入勝的麻將寵物冒險世界，一款充滿樂趣與放鬆的拼圖遊戲，將經典麻將與可愛的動物圖片巧妙結合！將經典麻將牌換成可愛的動物主題牌！每張牌都為遊戲增添了一絲迷人的樂趣。\n探索各種難度不同的關卡，每個關卡都設計來挑戰你的技能與邏輯思考。隨著你進度提升，難度也隨之增加，確保你始終面臨挑戰！",
      "instructions": "匹配動物磁磚的配對以清空遊戲板。\n您只能匹配未受限且未被其他磁磚阻擋的磁磚！\n清空所有磁磚以完成關卡，並進入下一關。",
      "genres": [
        "麻将 & 連線"
      ],
      "tags": [
        "3D",
        "動物",
        "連結",
        "邏輯",
        "配對"
      ]
    },
    "zh-HK": {
      "title": "麻將寵物冒險之旅",
      "description": "跳進色彩繽紛、充滿趣味的麻將寵物冒險世界，一款既有趣又放鬆的拼圖遊戲，其中經典的麻將與可愛的動物磁片相結合！每塊磁片都為遊戲帶來迷人、愉快的觸感。\n探索各種等級，每個等級都設計來考驗你的技巧和邏輯。隨著進度增加，難度也會提升，確保你總是面臨挑戰！",
      "instructions": "匹配動物圖片組合以清空遊戲板。\n您只能匹配未受阻礙且沒有其他圖片阻擋的圖片！\n清空所有圖片以完成關卡並進入下一關。",
      "genres": [
        "麻將 & 連結"
      ],
      "tags": [
        "3D",
        "動物",
        "連結",
        "邏輯",
        "配對"
      ]
    },
    "ja": {
      "title": "麻雀ペットクエスト",
      "description": "マジョンペットクエストのカラフルで魅力的な世界に飛び込みましょう。これは、伝統的なマジョンと可愛い動物タイルが融合した楽しいリラックスしたパズルゲームです！\n\n伝統的なマジョンタイルを可愛い動物テーマのものに置き換えてください。それぞれのタイルがゲームに魅力的で楽しいトーンを加えます。\n\n様々なレベルを探索し、それぞれがあなたのスキルと論理を試します。難度は進むにつれて上昇し、常に挑戦を感じさせます！",
      "instructions": "動物のタイルをペアで一致させ、ボードをクリアしてください。\n他のタイルに阻まれていない、解放されたタイルのみを一致させることができます！\nすべてのタイルをクリアしてレベルを完了し、次のレベルに進みます。",
      "genres": [
        "麻雀＆コネクト"
      ],
      "tags": [
        "3D",
        "動物",
        "連結",
        "論理",
        "一致"
      ]
    },
    "ko": {
      "title": "마작 펫 퀘스트",
      "description": "마작 펫 퀘스트의 다양하고 매력적인 세계로 뛰어들세요! 고전 마작과 귀염빠진 동물 타일이 만나져 기쁨과 쉼을 함께하는 패兹너스 게임입니다!\n고전 마작 타일을 귀엽고 동물 주제의 타일로 대체하세요! 각 타일이 게임에 사랑스럽고 즐거운 터치를 더합니다.\n여러 레벨을 탐험하세요. 각 레벨은 당신의 기술과 논리를 테스트할 수 있도록 설계되었습니다. 난이도는 진행에 따라 증가하며, 항상 도전을 받을 수 있습니다!",
      "instructions": "동물 타일을 짝을 맞추어 보드를 클리어하세요. \n 자유롭고 다른 타일로 막히지 않은 타일만을 짝을 맞출 수 있습니다! \n 모든 타일을 클리어하여 레벨을 완료하고 다음으로 넘어가세요.",
      "genres": [
        "마작 & 커넥트"
      ],
      "tags": [
        "3D",
        "동물",
        "연결",
        "논리",
        "매칭"
      ]
    },
    "fr": {
      "title": "Chasse aux Pets de Mahjong",
      "description": "Plongez dans le monde coloré et captivant de Mahjong Pet Quest, un jeu de puzzle amusant et relaxant où le Mahjong classique se rencontre avec des tuiles d'animaux adorable !\n\nRemplacez les tuiles de Mahjong classiques par des tuiles à thème animal mignonnes ! Chaque tuile apporte une touche charmante et délicieuse au jeu.\n\nExplorez une variété de niveaux, chacun conçu pour tester vos compétences et votre logique. La difficulté augmente au fur et à mesure de votre progression, assurant ainsi que vous êtes toujours challengé !",
      "instructions": "Assemblez des paires de tuiles d'animaux pour libérer le plateau. \nVous ne pouvez匹配只有自由且未被其他瓷砖阻挡的瓷砖！ \nLibérez toutes les tuiles pour terminer le niveau et passer au suivant.",
      "genres": [
        "Mahjong et Connect"
      ],
      "tags": [
        "3D",
        "animal",
        "connexion",
        "logique",
        "correspondance"
      ]
    }
  }
};
